import { useState, useEffect } from "react";
import { isBrowser } from "^/utils/isBrowser";

const CtrlWheelZoom = () => {
  // eslint-disable-next-line global-require
  const { useMap } = require("react-leaflet");
  const map = useMap();
  const [hint, setHint] = useState("");

  useEffect(() => {
    const container = map.getContainer();
    const handleWheel = (event) => {
      const ctrlOrMeta = event.ctrlKey || event.metaKey;
      if (!ctrlOrMeta) {
        event.stopImmediatePropagation();
        return;
      }
      event.preventDefault();
    };

    container.addEventListener("wheel", handleWheel, {
      passive: false,
      capture: true,
    });

    return () => {
      container.removeEventListener("wheel", handleWheel, {
        capture: true,
      });
    };
  }, [map]);

  useEffect(() => {
    const userAgent = window.navigator.userAgent || "";
    const isTouch =
      typeof window.navigator.maxTouchPoints === "number" &&
      window.navigator.maxTouchPoints > 0;
    const isMobile = /Mobi|Android|iP(hone|od|ad)|Windows Phone/i.test(
      userAgent
    );
    const isDesktop = !isTouch && !isMobile;

    if (!isDesktop) {
      setHint("");
      return;
    }

    const isMac = window.navigator.platform
      ? /Mac|iP(hone|ad|od)/i.test(window.navigator.platform)
      : /Mac|iP(hone|ad|od)/i.test(userAgent);

    setHint(isMac ? "Press ⌘ (CMD) to zoom" : "Press Ctrl to zoom");
  }, []);

  if (!isBrowser) return null;
  if (!hint) return null;

  return <div className="openstreetmap-widget-ctrl">{hint}</div>;
};

export default CtrlWheelZoom;
